import { isCompletelyEmpty, removeEmptyFields, removeEmptyObjects } from "../../utils/data";

const AliasTable = ({ alias }) => {
  console.log("valid alias before:", alias)
  removeEmptyFields(alias);
  removeEmptyObjects(alias);
    console.log("valid alias after:", alias)
  if (isCompletelyEmpty(alias)) return null;

  return (
    <>
      <th>Alias</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>First Name</th><th>Middle Name</th><th>Last Name</th><th>Suffix</th>
            <th>SSN</th><th>Birth Date</th><th>State</th><th>Driver License</th>
          </tr>
        </thead>
        <tbody>
          {alias.map((details, index) => (
            <tr key={index}>
              <td>{details.PersonName.FirstName}</td>
              <td>{details.PersonName.MiddleName}</td>
              <td>{details.PersonName.SurName}</td>
              <td>{details.PersonName.Suffix}</td>
              <td>{details.SSN}</td>
              <td>{details.DOB}</td>
              <td>{details.License.JurisdictionOfIssue}</td>
              <td>{details.License.LicenseNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AliasTable;
